// JOBE-0162.3: ownership helpers.
//
// The umbrella spec pins `ownedBy` as a relation; on the wire it surfaces
// as a scalar `ownerId` field on each directory row. These pure helpers
// project that scalar back into the bidirectional shape the W3 surfaces
// need (owns-N chip, owned-by link, profile owned-roster).
//
// Used by `OrganizationRoster` (chips/links) and `HumanProfilePage`
// (owned-roster from JOBE-0162.5).

/**
 * Count how many rows have `ownerId === ownerSlug`.
 *
 * @param {Array<{ownerId: string|null}>} rows
 * @param {string|null|undefined} ownerSlug
 * @returns {number}
 */
export function countOwnedBy(rows, ownerSlug) {
  if (!ownerSlug) return 0;
  return (rows || []).filter((r) => r && r.ownerId === ownerSlug).length;
}

/**
 * Find the row whose `id` matches `ownerId`. Returns `null` if not found
 * (defensive — fixtures pin ownership consistency, but the followup wire
 * endpoint may surface stale or dangling owner refs in production).
 *
 * @param {Array<{id: string}>} rows
 * @param {string|null|undefined} ownerId
 * @returns {object|null}
 */
export function lookupOwner(rows, ownerId) {
  if (!ownerId) return null;
  return (rows || []).find((r) => r && r.id === ownerId) || null;
}

/**
 * Return the subset of rows owned by `ownerSlug`.
 *
 * @param {Array<{ownerId: string|null}>} rows
 * @param {string|null|undefined} ownerSlug
 * @returns {Array}
 */
export function ownedBy(rows, ownerSlug) {
  if (!ownerSlug) return [];
  return (rows || []).filter((r) => r && r.ownerId === ownerSlug);
}
